export enum UnitStyleEnum {
    Legacy = 1,
    LegacyNextGen = 2,
    Dome = 3,
    IOModule = 4,
    SingleUnit = 5
}